import { Component, OnInit, Input } from '@angular/core';
import { AdvertisementService } from '../../service/advertisement.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute,Params } from '@angular/router';
import {Observable } from 'rxjs';
import 'rxjs/add/observable/interval';


@Component({
  selector: 'app-advertisement-forum',
  templateUrl: './advertisement-forum.component.html',
  styleUrls: ['./advertisement-forum.component.css'],
  providers: [AdvertisementService,Globals]
})

export class AdvertisementForumComponent implements OnInit {
  @Input() public section:string;
  
  adv:any;
  isError=false;
  msg:string;
  private timer;
  img:any='';

  constructor(public router:Router, private advertisementService:AdvertisementService, private global: Globals, private route: ActivatedRoute) {
    this.adv={ 
              image:'',
              title:'',
              link:''
             }
             //webassets/images/banner-pic.jpg
  }

  ngOnInit() {
 
    //this.section='Discussion';
    this.getrandomadvlist();
  }

  onTimeOut(allAdv) {
    this.adv = allAdv[Math.floor(Math.random()*allAdv.length)];
  }


  getAdvImage(imagename){
    return this.global.advertisementImageUrl+imagename;
  }

  getrandomadvlist(){
    let obj = {};
    obj['section'] = this.section;
    this.advertisementService.getrandomadvlist(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.adv=data.results[0];
        let allAdv = data.results;
        this.timer = Observable.interval(10000);
        this.timer.subscribe((t) => this.onTimeOut(allAdv));

      }else{
        this.isError = true;
        this.msg="There is some technical problem";
      }
    },
    (error: HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    })
  }


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/advertisement-forum/advertisement-forum.component.ts